import Module from "../singleton/module";

export default {

    getAll: Module.getAll.bind(Module),

    getDefault: Module.getDefault.bind(Module),

    get: Module.get.bind(Module),

    create: Module.create.bind(Module),

    update: Module.update.bind(Module),

    delete: Module.delete.bind(Module),

    setOrder: Module.setOrder.bind(Module),

    search: Module.search.bind(Module)

}